import React, { useEffect, useState } from 'react'
import TabComponent from 'src/components/common/Tab/Tab';
import { tabsUserProspects } from './constants/tabs-prospects';
import { useAppSelector } from 'src/hooks/redux';
import { selectProspects } from 'src/redux/prospects/prospectsSlice';
import { useHandleProspectTab } from './ProspectsTabs.helper';

const ProspectsTabs = () => {
    const [initialized, setInitialized] = useState(false);
    const { selectedSection } = useAppSelector(selectProspects);
    const { handleTabClick, loadProspectsSection, loading } = useHandleProspectTab();

    useEffect(() => {
        loadProspectsSection(initialized);
        setInitialized(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedSection, initialized]);

    return (
        <TabComponent tabs={tabsUserProspects} onTabClick={handleTabClick} isDisabled={loading} />
    )
}

export default ProspectsTabs